/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import axios from 'axios';
import $http from '../../plugins/axios';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export const invokegetAllProgram = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    console.log('Response', response);
    res = response.data.response.program_name;
    return res;
  });
  return res;
};

export const invokegetAllTaskByProgram = async (url: string, programId: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, programId).then((response) => {
    res = response.data.tasks;
    return res;
  });
  return res;
};

export const invokeGetAllGenAIReviewedSubmissions = async (url: string, payload: any) => {
  let res: any;
  // eslint-disable-next-line camelcase
  await $http.post(url, payload).then((response) => {
    res = response?.data?.data;
    return res;
  });
  return res;
};
export const getAllOffCycleByByProgram = async (url: string, programId: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, programId).then((response) => {
    res = response.data.learnerDetails;
    return res;
  });
  return res;
};
export const invokeArchieveTask = async (url: string, taskData: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, taskData).then((response) => {
    res = response.data.tasks;
    return res;
  });
  return res;
};
export const updateOffcyclestatus = async (url: string, taskData: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, taskData).then((response) => {
    res = response.data;
    return res;
  });
  return res;
};
export const getTaskById = async (taskId: any) => {
  let getTaskres: any;
  try {
    await $http.get(`/task/${taskId}`).then((response) => {
      getTaskres = response.data.data;
      return getTaskres;
    });
    return getTaskres;
  } catch (error) {
    return error;
  }
};
export const uploadBulkTasks = async (url: any, bulkTaskFile: any) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'put',
      body: bulkTaskFile,
    });
    const uploadResponse = res;
    return uploadResponse;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const importBulkTask = async (url: any, bulkTasData: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, bulkTasData).then((response) => {
    res = response.data.tasks;
    return res;
  });
  return res;
};

export const resetActiveTaskSequence = async (url: any, data: any) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.post(url, data).then((response) => {
    res = response.data.tasks;
    return res;
  });
  return res;
};

export const saveTask = async (data: any) => {
  console.log(`inside save task data ${JSON.stringify(data)}`);
  const savedRes = await $http.post('/task/create', data);
  return savedRes;
};

export const invokeExportTask = async (programId: string) => {
  try {
    let res;
    await $http.get(`/admin/task/taskExport/${programId}`).then(async (response) => {
      // console.log(response.data.sys_settings);
      res = response.data;
      // await downloadEdcastUrl(res, programName);
      // const fileLink = document.createElement('a');
      // fileLink.href = res;
      // fileLink.setAttribute('download', learnerSubmission);
      // document.body.appendChild(fileLink);

      // fileLink.click();
      // fileLink.download = 'EdcastUrl.csv';
      // fileLink.click();
      // URL.revokeObjectURL(fileLink.href);
      return res;
    });
    return res;
  } catch (error) {
    return error;
  }
};
